import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { GlobalNav } from '@nexus/fff-global-nav';
import { GlobalFooter } from '@nexus/fff-global-footer';
import { isLoggedIn } from '../../services';

const Layout = ({
  children, pageTitle, meta, isProtected,
}) => {
  useEffect(() => {
    if (isProtected) {
      isLoggedIn().then(({ ok }) => (!ok
        && window.location.replace(`${process.env.REACT_APP_LOGIN_URL}${window.location.href}`)));
    }
  }, [isProtected]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        {meta && meta.links && meta.links.map(({ href, ...link }, index) => (
          /*  eslint-disable-next-line react/no-array-index-key */
          <link key={`${href}${index}`} {...link} href={href} rel="stylesheet" type="text/css" />
        ))}
        {meta && meta.scripts && meta.scripts.map(({ src, ...script }, index) => (
          /* eslint-disable-next-line react/no-array-index-key */
          <script key={`${src}${index}`} {...script} src={src} />
        ))}
      </Helmet>
      <GlobalNav env={process.env.REACT_APP_ENVIRONMENT} />
      {children}
      <GlobalFooter />
    </>
  );
};

Layout.defaultProps = {
  pageTitle: 'Static Page',
  isProtected: false,
  meta: {},
};

Layout.propTypes = {
  pageTitle: PropTypes.string,
  isProtected: PropTypes.bool,
  meta: PropTypes.shape({
    links: PropTypes.arrayOf(String),
    scripts: PropTypes.arrayOf(String),
  }),
};

export default Layout;
